module.exports = __webpack_public_path__ + "img/icon34.7d44d0d0.png";